import { CheckCircle2, Circle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const FinishScreen = ({
	requiredDocs,
	uploadedFiles,
	isDownloaded,
	isDownloading,
	onDownload,
	onRestart,
	onBackToDocs,
}) => {
	const { t } = useTranslation('finish')
	const uploadedCount = Object.keys(uploadedFiles || {}).length

	// After the download all personal data is gone; there is nothing left to
	// list or download again.
	if (isDownloaded) {
		return (
			<div className='section-card finish-card'>
				<h2 className='section-title'>{t('title')}</h2>
				<p role='status'>{t('downloadedMessage')}</p>
				<p className='u-note-top'>{t('reviewHint')}</p>
				<div className='finish-actions'>
					<button className='btn-primary-action' onClick={onRestart}>
						{t('restartButton')}
					</button>
				</div>
			</div>
		)
	}

	return (
		<div className='section-card finish-card'>
			<h2 className='section-title'>{t('title')}</h2>
			<p>{t('successMessage')}</p>
			<p style={{ fontSize: '0.95rem', color: 'var(--text-secondary)', marginBottom: '25px' }}>
				{t('downloadHint')}
			</p>

			{requiredDocs.length > 0 && (
				<div className='finish-docs-box'>
					<h3>{t('docsListTitle')}</h3>
					<ul>
						{requiredDocs.map(doc => {
							const isUploaded = !!(uploadedFiles && uploadedFiles[doc.id])
							return (
								<li key={doc.id}>
									<span className='finish-docs-item-main'>
										{isUploaded ? (
											<CheckCircle2 size={16} color='#10b981' style={{ flexShrink: 0 }} />
										) : (
											<Circle size={16} color='var(--text-secondary)' style={{ flexShrink: 0 }} />
										)}
										<span>{t(`docs.${doc.id}.label`)}</span>
									</span>
									{!isUploaded && (
										<span className='finish-docs-missing-tag'>{t('missingTag')}</span>
									)}
								</li>
							)
						})}
					</ul>
					{uploadedCount < requiredDocs.length && (
						<button className='finish-docs-back-link' onClick={onBackToDocs}>
							{t('backToDocs')}
						</button>
					)}
				</div>
			)}

			<div className='finish-actions'>
				<button className='btn-primary-action' onClick={onDownload} disabled={isDownloading}>
					{isDownloading ? t('downloadingButton') : t('downloadButton')}
				</button>
				<button className='btn-secondary-action' onClick={onRestart}>
					{t('restartButton')}
				</button>
			</div>

			<p className='u-note-top'>{t('reviewHint')}</p>

			<p
				style={{
					fontSize: '0.8rem',
					color: 'var(--text-secondary)',
					marginTop: '15px',
					opacity: 0.8,
				}}
			>
				{t('dataDeletionHint')}
			</p>
		</div>
	)
}

export default FinishScreen
